'use client'

import {HubspotContactForm} from '@/app/[locale]/contact/HubspotForm'
import {ConeStarlikeSunburstIcon} from '@/components/ui/icons/graphical-elements'
import {MailIcon} from '@/components/ui/icons/MailIcon'
import {TopSectionWithIcon} from '@/components/ui/TopSectionWithIcon'
import {Display, Text} from '@/components/ui/Typography'
import {useTranslations} from '@/i18n/hooks/useTranslations'
import React from 'react'

export const Contact: React.FC<{locale?: string}> = ({locale}) => {
  const t = useTranslations()
  const infoEmail = t('contact.infoEmail')

  return (
    <main>
      <TopSectionWithIcon
        title={t('contact.title')}
        subTitle={t('contact.subTitle')}
        icon={<ConeStarlikeSunburstIcon className="w-80 h-80" />}
        text={t('contact.description')}
        bgColor={'bg-piffl-pink-500'}
        titleColor={'text-white'}
      />
      <section className="flex justify-center mb-20">
        <div className="container w-full max-w-3xl">
          <Display className="mb-2">{t('contact.contactTitle')}</Display>
          <Text className="mb-6">{t('contact.contactDescription')}</Text>
          <HubspotContactForm locale={locale} />
          <div className={'flex justify-center'}>
            <div className="flex flex-col md:flex-row md:items-center">
              <Text className="mb-1 flex items-center gap-2">
                <MailIcon className="w-6 h-6 text-court-600" />
                <a className="font-bold text-court-600" href={`mailto:${infoEmail}`}>
                  {infoEmail}
                </a>
              </Text>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
